import { call, put, takeLatest } from "redux-saga/effects";
import {ToasterService} from "../../../services/toaster/toaster.service";
import { API } from "../../../api/api";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";

function* uploadConfigurationRemotely(action) {
    try {
        yield call(() =>
            hallsAPI.uploadConfigurationRemotely({
                serverId: action.payload.serverId,
                update_time: action.payload.update_time,
                include_server_config: action.payload.include_server_config,
                include_game_logos: action.payload.include_game_logos,
                game_rtp_profiles: action.payload.game_rtp_profiles
            })
        );
        yield put({
            type: HallsActionTypes.UPLOAD_CONFIGURATION_REMOTELY_SUCCESS
        });

        ToasterService.successToast("Configuration was successfully upload remotely");

    } catch (e) {
        API.handleError(e.response);

        yield put({
            type: HallsActionTypes.UPLOAD_CONFIGURATION_REMOTELY_FAIL,
            message: e.message
        });
    }
}

export function* uploadConfigurationRemotelyWatcher() {
    yield takeLatest(
        HallsActionTypes.UPLOAD_CONFIGURATION_REMOTELY,
        uploadConfigurationRemotely
    );
}
